export default {
  name: 'BankLookupSectionV2',
  props: {
    history: {
      type: Array,
      default: () => []
    },
    query: {
      type: String,
      default: ''
    },
    result: Object,
    logEvent: {
      type: Function,
      default: () => {}
    },
    onRedirect: Function,
    dark: Boolean
  },
  data() {
    return {
      animate: false,
      loading: false,
      loaded: false,
      redirectURL: null
    };
  },
  watch: {
    query(newVal) {
      if (this.result && newVal !== this.result.name) {
        this.$emit('update:result', null);
      }
    },
    result(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.animate = true;
        }, 600);
      } else {
        this.animate = false;
      }
    }
  },
  mounted() {
    const url = new URL('https://extra.app/application');
    window.g_user_tag && url.searchParams.set('user_tag', window.g_user_tag);
    window.g_device_tag && url.searchParams.set('device_tag', window.g_device_tag);
    this.redirectURL = url;
    console.log({
      url
    });
  },
  methods: {
    btn(e) {
      // if (this.loaded && this.result) {
      // 	return this.redirect()
      // }
      // if (this.loaded && !this.result) {
      // 	return this.reset()
      // }
      if (this.loaded) {
        return this.reset();
      }
      return this.lookupBank(e);
    },
    lookupBank(e) {
      if (this.loading || this.result || !this.query) {
        return;
      }
      this.loading = true;
      this.$axios.$post('/api/bank-lookup', {
        query: this.query
      }, {
        progress: false
      }).then(({
        bank
      }) => {
        if (bank) {
          this.$emit('update:result', bank);
          this.logEvent('bank_lookup', true);
          // this.$emit('update:query', bank.name)
        } else {
          this.logEvent('bank_lookup', false);
        }
      }).catch(err => {
        alert('Something went wrong... Please try again');
        console.error(err);
        this.$sentry.captureException(err);
      }).finally(() => {
        this.loading = false;
        this.$emit('update:history', [...(this.history || []), this.query]);
        e && e.srcElement && e.srcElement.blur();
        this.loaded = true;
      });
    },
    reset() {
      this.loaded = false;
      this.$emit('update:result', null);
      this.$emit('update:query', '');
    },
    redirect() {
      // this.reset()
      if (this.onRedirect) {
        this.onRedirect(this.redirectURL);
      } else {
        window.location.href = this.redirectURL;
      }
    }
  }
};